export default class ManuallyPostInterestRequest {
    accountId: string;
    walletId: string;
}